export const EventAttendConfirmationTranslations = {
  SELECT_CALENDARY: {
    es: 'Elige el calendario que usas',
    en: 'Select the calendar you use',
    cat: 'Elige el calendari que utilitzes',
    eus: 'Ezabatu',
    pt: 'Selecione o calendário que utiliza'
  },
  CHECK_CALENDARY: {
    es: 'Guardar siempre este calendario',
    en: 'Save this calendar always',
    cat: 'Guardar sempre aquest calendari',
    eus: 'Gorde hemen den egunen',
    pt: 'Salvar este calendário sempre'
  },
  SAVE_CALENDAR_SUCCESS: {
    es: 'Calendario guardado',
    en: 'Calendar saved',
    cat: 'Calendari guardat',
    eus: 'Ikastarok gaurdatu',
    pt: 'Calendário salvo'
  },
  YOU_WILL_ATTEND_TO_AN_EVENT: {
    es: 'Te has apuntado al Evento',
    en: 'You will attend to the Event',
    cat: "T'has apuntat a l'Event",
    eus: 'Gertaerara apuntatu zara',
    pt: 'Você se inscreveu no evento'
  },
  WE_WILL_SEND_YOU_A_REMINDER: {
    es: 'Te enviaremos un correo 15 minutos antes del evento.',
    en: 'We will send you a reminder 15 minutes before the event.',
    cat: 'T`enviarem un correu 15 minuts abans de l`event.',
    eus: 'Gertaera 15 minutu lehenago, korreo bat bidaliko dizugu.',
    pt: 'Vamos enviar um lembrete 15 minutos antes do evento.'
  },
  ADD_TO_CALENDAR: {
    es: 'Añadir al calendario',
    en: 'Add to calendar',
    cat: 'Afegir al calendari',
    eus: 'Egunerakoan gehitu',
    pt: 'Adicionar ao calendário'
  },
  SAVE_CALENDAR: {
    es: 'Guardar el calendario',
    en: 'Save the calendar',
    cat: 'Guardar el calendari',
    eus: 'Gorde hemen den egunen',
    pt: 'Salvar o calendário'
  }
};
